import TagManager from 'react-gtm-module'

import Accordion from 'Root/App/Item/Accordion'
import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'
import mixpanelTrack from 'lib/mixpanel-track'

import styles from './index.module.css'

const Faq = ({ faqList, collectionSlug, collectionTitle }) => {
  const handleFaqOpen = (title) => {
    mixpanelTrack('Faq aperta', {
      id_corso: collectionSlug,
      nome_corso: collectionTitle,
      nome_faq: title,
    })

    TagManager.dataLayer({
      dataLayer: {
        event: 'tay_collection_faq_open',
        faqTitle: title,
        collectionSlug: collectionSlug,
      },
    })
  }

  return (
    <section className={styles.faqWrapper} aria-label="Course FAQ">
      <Title className={styles.faqTitle}>Domande frequenti</Title>
      <ul className={styles.faqList}>
        {faqList.map((faq, index) => (
          <li key={`course-faq-${index + 1}`}>
            <Accordion
              title={faq.title}
              titleCustomClass={styles.faqItemTitle}
              onOpen={() => handleFaqOpen(faq.title)}
            >
              <Paragraph>{faq.description}</Paragraph>
            </Accordion>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default Faq
